import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=5c1e1870&scoped=true"
import script from "./GalleryItem.vue?vue&type=script&lang=ts"
export * from "./GalleryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e1870",
  null
  
)

export default component.exports